// extracted by mini-css-extract-plugin
export default {"slidercontents":"MainCarousel_slidercontents__Kro5P","wrapText":"MainCarousel_wrapText__8H9f9"};